import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getCookie, setCookie } from './cookie'

export const sessionExpires = new Date(0)

const BASE_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/`
  : window.location.protocol + '//' + window.location.hostname + ':4000/'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const conf: AxiosRequestConfig = {
  baseURL: BASE_URL,
  timeout: 120000,
  withCredentials: true
}

// Adding AWS api-gateway Authorization code to header
// if it is found from cookie named "lottaAGA"

const apiGatewayAuthorization = getCookie('lottaAGA')

if (apiGatewayAuthorization && apiGatewayAuthorization.length) {
  conf.headers = { Authorization: apiGatewayAuthorization }
}

const responseHandler = (response: AxiosResponse) => {
  const lottaAGA = getCookie('lottaAGA')
  const lottaMaxAge = getCookie('lottaMaxAge')

  if (lottaAGA && lottaMaxAge) {
    // Refreshing lottaAGA cookie
    setCookie('lottaAGA', lottaAGA, lottaMaxAge)
    // Updates session sessionExpires
    sessionExpires.setTime(new Date().getTime() + parseInt(lottaMaxAge))
  }

  return response
}

/**
 * Axios request instance.
 * @returns AxiosInstance pointing to api's root (so we could call /session etc.)
 */
const requestBaseUrl = axios.create(conf)
requestBaseUrl.interceptors.response.use(responseHandler)

/**
 * Axios request instance.
 * @returns AxiosInstance which baseURL is pointing to /api
 */
conf.baseURL = BASE_URL + 'api'
const request = axios.create(conf)
request.interceptors.response.use(responseHandler)

export { requestBaseUrl, request }
